<template>
  <li class="mega-menu__menu-item mega-menu__menu-item--depth-2">
    <template v-if="itemIsDefined(itemDepth1, 'childMenu')">
      <button
        class="mega-menu__link mega-menu__button mega-menu__link--depth-2"
        @click="toggleNextDepth"
      >
        {{ itemDepth1.label }}
        <chevron-right />
      </button>
      <ul
        class="mega-menu mega-menu--depth-3"
        :class="nextDepthOpen ? 'mega-menu--depth--show' : ''"
      >
        <button class="mega-menu__title" @click="backOneLevel">
          <chevron-right />
          {{ itemDepth1.label }}
        </button>
        <a
          :href="getLink(itemDepth1)"
          class="mega-menu__link mega-menu__link--depth-3"
          >{{ itemDepth1.title }}</a
        >
        <mobile-menu-level-3
          v-for="(itemDepth2, index) in itemDepth1.childMenu"
          :key="`mobile-3-${index}`"
          :itemDepth2="itemDepth2"
        />
      </ul>
    </template>
    <a v-else-if="itemIsDefined(itemDepth1, 'link.url')"
      :href="getLink(itemDepth1.link)"
      class="mega-menu__link mega-menu__link--depth-2"
      >{{ itemDepth1.link.title }}</a
    >
  </li>
</template>

<script>
import MobileMenuLevel3 from "@/components/layout/header/MobileMenu/MobileMenuLevel3";
import ChevronRight from "@/components/layout/header/icons/ChevronRight";
import mainSite from "@/util/mainSite"

export default {
  name: "mobile-menu-level-2",
  components: {
    MobileMenuLevel3,
    ChevronRight,
  },
  mixins: [mainSite],
  data() {
    return {
      nextDepthOpen: false,
    };
  },
  props: {
    itemDepth1: {
      type: Object,
      required: true,
      default: {}
    },
  },
  methods: {
    toggleNextDepth() {
      this.nextDepthOpen = !this.nextDepthOpen;
    },
    backOneLevel() {
      this.nextDepthOpen = false;
    },
  },
};
</script>